import { workerFetch } from "./worker-base";

export interface StalkerChannel {
  id: string;
  name: string;
  num: string | null;
  logo: string | null;
  group: string;
  url: string | null;     // cmd from the portal
  epgId: string | null;
  type: "live";
}

export function cleanStalkerStreamUrl(raw: string, portal: string): string {
  let cleaned = raw.trim();
  if (cleaned.startsWith("ffmpeg ")) cleaned = cleaned.substring(7);
  if (cleaned.includes("localhost") || cleaned.includes("127.0.0.1")) {
    try {
      const portalHost = new URL(portal).host;
      cleaned = cleaned
        .replace(/localhost(:\d+)?/g, portalHost)
        .replace(/127\.0\.0\.1(:\d+)?/g, portalHost);
    } catch {
      // keep original
    }
  }
  return cleaned;
}

export const StalkerAdapter = {
  async listChannels(portal: string, mac: string): Promise<{ channels: StalkerChannel[]; total: number }> {
    const qs = new URLSearchParams({ portal, mac }).toString();
    const res = await workerFetch(`/stalker/channels?${qs}`, { timeoutMs: 20000 });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Stalker channels: HTTP ${res.status} — ${text}`);
    }
    return res.json();
  },

  async resolveStreamUrl(portal: string, mac: string, cmd: string, contentType: "live" | "vod" | "series" = "live"): Promise<string> {
    const qs = new URLSearchParams({ portal, mac, cmd, content_type: contentType }).toString();
    const res = await workerFetch(`/stalker/stream?${qs}`);
    if (!res.ok) throw new Error(`Stalker stream: HTTP ${res.status}`);
    const data: { url: string } = await res.json();
    return cleanStalkerStreamUrl(data.url, portal);
  },
};
